module.exports = __webpack_public_path__ + "static/media/ils_alternate_assets.cbfccfed.svg";